export const getClientEnv = (key) => {
    const runtimeValue =
        typeof window !== 'undefined'
            ? window.__RUNTIME_CONFIG__?.[key]
            : undefined;

    const buildValue =
        typeof process !== 'undefined'
            ? process.env?.[key]
            : undefined;

    return runtimeValue || buildValue;
};